import getReportingOption from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('saveReportingOptionHelper', function saveReportingOptionHelper() {
    const reportingOptionState = getReportingOption();
    const userConfiguration = getUserConfiguration();

    if (reportingOptionState.reportJunkSelected != null) {
        userConfiguration.UserOptions.ReportJunkSelected = reportingOptionState.reportJunkSelected;
    }
    if (reportingOptionState.checkForReportJunkDialog != null) {
        userConfiguration.UserOptions.CheckForReportJunkDialog =
            reportingOptionState.checkForReportJunkDialog;
    }
});
